<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast 1" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeModal">
      <div class="uk-modal-header">
        <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 2"
             style="cursor: pointer;"
             @click="closeModal">
          <md-icon>close</md-icon>
        </div>
        <div class="uk-modal-title">
          <div class="uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
            <div class="uk-text-bold">
              <h4 class="uk-text-bold">Видео инструкция</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-modal-body">
        <div class="uk-text-center uk-margin-top uk-grid uk-grid-small uk-flex-center tm-dialog-buttons">
          <div class="uk-margin-auto">
            <video src="/video/functions_description_probability.mp4" controls data-uk-video="autoplay: false"></video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {},
  methods: {
    closeModal() {
      this.$emit('hide', true);
    },
  },
}
</script>